import React, { useState } from 'react';
import InputSelect from 'components/Inputs/inputSelect';
import { Button } from 'xland-ui';
import { useSelector } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { ROUTE_PATH } from 'routes';
import FormLayout from 'layouts/FormLayout';
import StartupSearcher from 'components/StartupSearcher';

function PreOnboarding() {
  const literals = useSelector(state => state.i18n.literals.onboarding);
  const literalsCommon = useSelector(state => state.i18n.literals.common);
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const [type, setType] = useState(searchParams.get('type'));
  const [role, setRole] = useState('');
  const [investment, setInvestment] = useState();

  const handleNext = () => {
    const auxId = investment?.id && investment?.id !== 'other' ? investment?.id : null;
    const auxParams = investment?.id === 'other' ? { name: investment?.name } : {};
    const auxType = type === 'company' && role ? [type, role].join('_') : type;
    navigate(ROUTE_PATH.setOnboardingInvestment(auxType, auxId, auxParams));
  };

  return (
    <FormLayout title={literals.investmentAssets} className='form-auth'>
      <form onSubmit={handleNext}>
        <div className='row'>
          <div className='col-12'>
            <InputSelect
              placeholder={literalsCommon.type}
              value={type}
              onChange={setType}
              options={[
                { id: 'company', name: literals.company },
                { id: 'fund', name: literals.fund },
                { id: 'listedCompany', name: literals.listedCompany },
                { id: 'realEstate', name: literals.realEstate },
                { id: 'crypto', name: literals.crypto },
                { id: 'other', name: literals.other },
              ]}
            />
          </div>
          {type === 'company' && (
            <InputSelect
              placeholder={literalsCommon.role}
              value={role}
              onChange={setRole}
              options={[
                { id: '', name: literals.investor },
                { id: 'founder', name: literals.founder },
                { id: 'guest', name: literals.guest },
              ]}
            />
          )}
          <div className='col-12'>
            <StartupSearcher
              placeholder={literals.writeStartupName}
              value={investment}
              onChange={setInvestment}
              type={type}
              isDisabled={!type}
              isRequired
            />
          </div>
        </div>
        <div className='buttons'>
          <Button text={literals.next} type='submit' disabled={!type || !investment?.id} />
        </div>
      </form>
    </FormLayout>
  );
}

export default PreOnboarding;
